<template>

  <div>

    <t-msg info>Caso desejar, é possível atribuir fases de execução do local, podendo depois especificar qual
      fase a inspeção faz parte.<br /><br />

      Confira a seguir as regras para que o sistema aplique a fase padrão na inspeção:<br /><br />
      <ol>

        <li>Caso não possuir nenhuma fase, será oculta a informação na inspeção.</li>
        <li>Caso possuir somente uma fase, será está a padrão.</li>
        <li>Caso possuir mais que uma fase o critério de desempate será aquela que não possuir a data de finalização</li>
        <li>Caso possuir mais que uma fase e todas já conterem a data de término da execução, por tanto será a última fase com maior data de término de execução.</li>

      </ol>

     Obs.: O inspetor poderá selecionar outra fase diferente do padrão livremente, desde que haja 2 fases ou mais no local.

    </t-msg>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="enterpriseStepId" :primary-key="form.enterpriseStepId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Fases" sortable
                 @onChangeOrder="refreshItems"
                 @onSubmit="onSubmit"
                 @onItemRead="onItemReadDefault"
                 @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.enterpriseStepId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="9">

            <b-row>

              <t-input cols="3"
                       v-model="form.name"
                       label="Fase denominação"
                       :add-error="error.name"
                       required/>

              <t-input cols="3" v-model="form.startDate"
                       label="Data Início" help="Utilize as datas somente para controle interno de qual o período de cada fase, porém no momento do vínculo na inspeção não será exigido ou verificada a data, somente informada."
                       date small="Preencha a data início somente quando iniciar a execução da fase" />

              <t-input cols="3" v-model="form.finishDate"
                       label="Data Término"  help="Utilize as datas somente para controle interno de qual o período de cada fase, porém no momento do vínculo na inspeção não será exigido ou verificada a data, somente informada."
                       date small="Preencha a data término somente quando concluir a execução da fase" />

              <t-input cols="3" v-model="form.note" label="Obs."/>

            </b-row>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>


        </b-row>


      </b-col>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'EnterpriseStep',
  data() {
    return {
      path: "place/enterprise-step", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "enterpriseId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "enterpriseStepId", keyDelete: "enterpriseStepId"},
        {key: "name", label: "Descrição", cols: "2"},
        {key: "startDate", label: "Data Início", cols: "3", formatter: "date"},
        {key: "finishDate", label: "Data Término", cols: "3", formatter: "date"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        enterpriseId: this.foreignKey,
        enterpriseStepId: 0,
        name: "",
        startDate: "",
        finishDate: "",
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------

      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.enterpriseStepId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
